
/* styles */
require("!!../../../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-0f4b1205!sass-loader?sourceMap!../../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./PaperShow.vue")

var Component = require("!../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./PaperShow.vue"),
  /* template */
  require("!!../../../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-0f4b1205!../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./PaperShow.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/domains/event/components/show/paper/PaperShow.vue
// module id = 672
// module chunks = 2